/**
 * LaTeX Renderer Component
 * Renders mathematical equations using KaTeX
 * @module LatexRenderer
 */

import React, { memo } from "react";
import PropTypes from "prop-types";
import Latex from "react-latex-next";
import "katex/dist/katex.min.css";

/**
 * Renders LaTeX mathematical expressions
 * @param {Object} props - Component props
 * @param {string} props.latex - LaTeX string to render
 * @param {Object} [props.style] - Custom inline styles
 * @param {string} [props.className] - CSS class name
 * @returns {JSX.Element} Rendered LaTeX expression
 */
export const LatexRenderer = memo(({ latex, style, className }) => {
  if (!latex) {
    return null;
  }

  return (
    <div className={className} style={style}>
      <Latex>{latex}</Latex>
    </div>
  );
});

LatexRenderer.displayName = "LatexRenderer";

LatexRenderer.propTypes = {
  latex: PropTypes.string.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
};

LatexRenderer.defaultProps = {
  style: {},
  className: "",
};